import { AlertDialog } from '@/components/alert-dialog'
import type { DialogActionValue } from '@/components/create-dialog'
import { createGuard, type Guard } from '@/utils/guards/create-guard'

export const confirmDialogGuard = <T extends unknown[]>({
  title = 'Você tem certeza?',
  description = 'Esta ação é irreversível.',
  confirmValue = 'confirm',
}: Parameters<(typeof AlertDialog)['show']>[0] & {
  confirmValue?: DialogActionValue
}): Guard<T> =>
  createGuard<T>(async () => {
    const result = await AlertDialog.show({ title, description })
    return result.value === confirmValue
  })
